<cc-apps-tool-bar *ngIf="app" [app]="app" (add)="onAddForm()" [canAdd]="canAdd"></cc-apps-tool-bar>
<cc-work-flow [canAddForm]="canAdd" [context]="context"></cc-work-flow>
<router-outlet></router-outlet>
